module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0129.jpg?v=ff4c5760";